<div class="form-field">
  <div class="form-control-container">
    @if (name) {
      <label class="label" [class.bold]="bold" [attr.for]="inputId">
        <span>{{name}}</span>
      </label>
    }
    <input
      [id]="inputId"
      [formControl]="control"
      [placeholder]="placeholder"
      [type]="formControlType"
      class="form-control main-input"
      autocomplete="off"
      (focus)="removePlaceholder()"
      (blur)="setPlaceholder()"
      [maxlength]="codeLength"
      type="text"
      inputmode="numeric"
      >
  </div>
  @if (showError) {
    <div class="input-error">
      <span>{{errorPresentation}}</span>
    </div>
  }
</div>
